export enum cryptoLocalStorage {
    KEY = 'LOCALSTORAGE',
}